import React from 'react';
import PropTypes from 'prop-types';
import kebabCase from 'lodash/kebabCase';
import { ButtonWithIcon } from '@els/els-react--button';
import { TooltipConstants } from '@Components/Tooltip';
import { ProjectStatus, ProjectSynthesisJobType } from '@Pages/RetroSynthesis/constants';
import HoverTooltip from '@Components/HoverTooltip';

function StatusFlagged({ type, status, tooltipContent, onClick = () => {}, label = 'Click here\nfor options' }) {
  const formattedStatus = kebabCase(status);

  return (
    <HoverTooltip id={TooltipConstants.ids.GlobalHover} tooltip={tooltipContent} place="left" theme="simple">
      <ButtonWithIcon
        type="link"
        size="small"
        linkIconSize="xs"
        sprite="Flag"
        onClick={onClick}
        className={`project-status-grid-item__flagged-button u-els-color-extended-red-9 u-els-font-size-meta o-els-flex-layout--middle e2e-${formattedStatus}-${type}`}
        aria-label={label}>
        {label}
      </ButtonWithIcon>
    </HoverTooltip>
  );
}

StatusFlagged.propTypes = {
  type: PropTypes.oneOf(ProjectSynthesisJobType.allTypes),
  status: PropTypes.oneOf(ProjectStatus.allTypes),
  tooltipContent: PropTypes.node,
  onClick: PropTypes.func,
  label: PropTypes.string,
};

export default StatusFlagged;
